var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 37,
    viewBox: "0 0 55 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4346 7.21688L18.5671 23.8835M34.8908 22.157L27.6739 26.3237M17.0671 21.2855L23.4004 32.2551C24.3338 33.8719 24.8005 34.6802 25.4717 35.1161C26.062 35.4995 26.7586 35.6861 27.4616 35.6493C28.2608 35.6074 29.0691 35.1407 30.6859 34.2073L50.3158 22.8739C51.9325 21.9405 52.7409 21.4738 53.1767 20.8026C53.5601 20.2123 53.7468 19.5157 53.7099 18.8127C53.668 18.0136 53.2013 17.2052 52.2679 15.5885L45.9346 4.6188C45.0012 3.00207 44.5344 2.1937 43.8633 1.75785C43.2729 1.37446 42.5763 1.18781 41.8734 1.22465C41.0742 1.26654 40.2658 1.73325 38.6491 2.66667L19.0192 14C17.4025 14.9334 16.5941 15.4001 16.1582 16.0713C15.7749 16.6617 15.5882 17.3582 15.625 18.0612C15.6669 18.8604 16.1336 19.6687 17.0671 21.2855Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 15.1016H1M12 21.7682H7.66667M15 30.1016L6.33333 30.1016C4.46649 30.1016 3.53307 30.1016 2.82003 29.7383C2.19282 29.4187 1.68289 28.9087 1.36331 28.2815C1 27.5685 1 26.6351 1 24.7682L1 12.1016C1 10.2347 1 9.3013 1.36331 8.58826C1.68289 7.96105 2.19283 7.45112 2.82003 7.13154C3.53307 6.76823 4.46649 6.76823 6.33334 6.76823L18 6.76823",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCards);
export default __webpack_public_path__ + "static/media/iconCards.43296ac791b2e1c4a39ff0bd3a229f2c.svg";
export { ForwardRef as ReactComponent };